import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export type DeductItemFlow = '0' | '1'

export interface DeductItemFilters {
  flow: DeductItemFlow | ''
  reason: string
}

export interface DeductItemRecord {
  id: number | string
  reason: string
  flow: DeductItemFlow
  point: number | string
}

export interface DeductItemPayload {
  reason: string
  flow: DeductItemFlow
  point: number | string
}

export async function fetchDeductItemPage(
  query: PageQuery<DeductItemFilters>,
  signal: AbortSignal
): Promise<PageResult<DeductItemRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/deductItem/queryByCondition',
    params: {
      ...query.filters,
      pageNo: query.pageNo,
      pageSize: query.pageSize
    },
    signal
  })
  return normalizePageResult<DeductItemRecord>(payload)
}

export function createDeductItem(payload: DeductItemPayload) {
  return requestV2.post<void>({
    url: '/main/deductItem/add',
    data: payload
  })
}

export function updateDeductItem(
  id: DeductItemRecord['id'],
  payload: DeductItemPayload
) {
  return requestV2.put<void>({
    url: `/main/deductItem/${id}`,
    data: payload
  })
}

export function deleteDeductItem(id: DeductItemRecord['id']) {
  return requestV2.delete<void>({
    url: `/main/deductItem/${id}`
  })
}
